<template>
  <div class="brands" v-if="!loading"></div>
  <div class="brands" v-else>
    <div class="brands-alphabet" :class="{hasBanner: bannerStatus}">
      <ul>
        <li v-for="(brand, index) in brands" :key="index" :class="{active: currentLetter === brand.LETTER}" @click="selectLetter(brand.LETTER)">
          <span>{{ brand.LETTER }}</span>
        </li>
      </ul>
    </div>
    <div v-for="(brand, index) in brands" :key="brand.NAME" class="brands-category" :id="brand.LETTER">
      <h1 class="brands-title">{{brand.LETTER}}</h1>
      <div class="brands-list">
        <ul>
          <li v-for="b in brand.BRANDS" :key="b.ID">
            <router-link  :to="{name: 'catalog.brand', params: {name: b.CODE}}">{{b.UF_NAME}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style src="@/assets/style/company/brands.scss" scoped lang="scss"></style>
<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'Brands',
    metaInfo() {
      return {
        title: 'Бренды - EXCELSIOR',
        meta: [{
          vmid: 'description',
          name: 'description',
          content:  'Бренды - интернет магазин EXCELSIOR.FASHION'
        }]
      }
    },
    data () {
      return {
        currentLetter: null,
      }
    },
    computed: {
      ...mapGetters({
        bannerStatus: 'headerBanner/status',
        brands: 'brands/brands',
        loading: 'brands/isLoaded'
      }),
    },
    methods: {
      selectLetter (letter) {
        this.currentLetter = letter;
        const element = document.getElementById(letter);
        window.scrollTo({
          top: element.offsetTop ,
          left: 100,
          behavior: 'smooth'
        });
      },
      ...mapActions({
        loadBrands: 'brands/getList',
      })
    },
    mounted () {
      if(!this.brands)
        this.loadBrands()
    },
    serverPrefetch(){
      return this.loadBrands();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Company/Brands.vue